import { z } from "zod";

import { TaskStatus } from "@/src/models/task";
import { TaskStepStatus } from "@/src/models/task-step";

export const workflowResumeIntentSchema = z.object({
  token: z.uuid(),
  taskStepId: z.uuid(),
  stepUpdatedAt: z.string().datetime({ offset: true }),
  stepStatus: z.enum([TaskStepStatus.COMPLETED, TaskStepStatus.FAILED]),
  fromStatus: z.enum([TaskStatus.AWAITING_INFORMATION, TaskStatus.REVIEW_NEEDED, TaskStatus.FAILED]),
  state: z.enum(["pending", "started"]),
});
export type WorkflowResumeIntent = z.infer<typeof workflowResumeIntentSchema>;

export const workflowStepResumeRequestSchema = z.object({ taskStepId: z.uuid() });
export type WorkflowStepResumeRequest = z.infer<typeof workflowStepResumeRequestSchema>;

export const workflowStepResumeCheckSchema = z.discriminatedUnion("resumable", [
  z.object({ resumable: z.literal(true), taskStepId: z.uuid() }),
  z.object({ resumable: z.literal(false), reason: z.string() }),
]);

export const workflowStepResumeResponseSchema = z.object({ resumed: z.literal(true) });
